import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';

//  Constants
import * as routeConstants from './constants/routesConstants';

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

// Containers
import Full from './containers/Full/'

// Views
import Wip from './views/Pages/Wip/'
import UserManagement from './components/UserManagement'
import Login from './views/Pages/Login/'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render((
  <HashRouter>
    <Switch>
      <Route exact path={routeConstants.WORK_IN_PROGRESS} name="Work In Progress" component={Wip}/>
      {/* <Route exact path={routeConstants.LOGIN} name="Login Page" component={Login}/> */}
      {/* <Route exact path={routeConstants.REGISTER} name="Register Page" component={Register}/> */}
      <Route path={routeConstants.USER_MANAGEMENT} name="User Management" component={UserManagement}/>
      {/* <Route exact path="/404" name="Page 404" component={Page404}/> */}
      {/* <Route exact path="/500" name="Page 500" component={Page500}/> */}
      <Route path={routeConstants.LANDING} name="Home" component={Full}/>
    </Switch>
  </HashRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js